<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-user-dropdown
      name="privateUsers"
      formControlName="privateUsers"></app-user-dropdown>
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'title'"
      [formField]="form.get('title')">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper
      *ngIf="
        !itemToEdit ||
        (itemToEdit &&
          this.activeUserStore.user() &&
          itemToEdit.user === this.activeUserStore.user()?._id)
      "
      [colSize]="4"
      [label]="'Privat'"
      [name]="'private'"
      [floatingLabel]="true">
      <p-inputSwitch id="private" formControlName="private"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>

  <p-divider />
  <div class="grid">
    <app-workspace-dropdown
      name="workspaces"
      type="bookmarkCategory"
      formControlName="workspaces"></app-workspace-dropdown>
  </div>
  <p-divider />

  <app-header
    text="Welche Ansichten sollen diesem Bereich zugeordnet werden?"
    icon="fas fa-note-sticky"></app-header>
  <div class="card" *ngIf="bookmarkStore.initialized()">
    <p-pickList
      [source]="bookmarks"
      [target]="categoryBookmarks"
      sourceHeader="Ansichten"
      targetHeader="Auswahl"
      [showSourceControls]="false"
      [dragdrop]="true"
      [responsive]="true"
      [sourceStyle]="{ height: '30rem' }"
      [targetStyle]="{ height: '30rem' }"
      filterBy="title"
      sourceFilterPlaceholder="Suche"
      targetFilterPlaceholder="Suche"
      breakpoint="1400px"
      (onMoveToSource)="updateFormValue()"
      (onMoveToTarget)="updateFormValue()"
      (onTargetReorder)="updateFormValue()"
      (onMoveAllToSource)="updateFormValue()"
      (onMoveAllToTarget)="updateFormValue()">
      <ng-template let-bookmark pTemplate="item">
        <div *ngIf="bookmark" class="flex-1 flex flex-column gap-2">
          <div class="flex align-items-center gap-2">
            <i class="fas fa-note-sticky"></i>
            <span>{{ bookmark.title }}</span>
          </div>
          @if (bookmarkConflicts[bookmark._id]; as conflictTitles) {
            <span class="text-color-secondary text-sm ml-4">
              <i class="fas fa-triangle-exclamation text-yellow-500 mr-1"></i>
              bereits in „{{ conflictTitles }}“
            </span>
          }
        </div>
      </ng-template>
    </p-pickList>
  </div>
  <p-divider />
  <app-form-footer
    [cancelLevel]="cancelLevel"
    (cancel)="cancel.emit()"
    [hideCancelLink]="disableCancelLink"
    [showRemoveButton]="
      !!itemToEdit &&
      permissionService.checkBookmarkRights(itemToEdit._id, 'remove')
    "
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
